<div class="flex items-center justify-center dialog-header ">
    {{singatureAction}} Signature

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content">
    <form [formGroup]="signatureForm">
        <p-editor id="editor" formControlName="newSignature" class="w-full"
        [(ngModel)]="signatureForm.controls['newSignature'].value"
                  [style]="{ height: '300px' }">
        </p-editor>

        <button pButton [label]="singatureAction + ' Signature'"
        class="mt-4 w-full"
                (click)="saveSignature()" [disabled]="signatureForm.invalid">
        </button>
    </form>
</div>
